import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { commonHeaderLinkLists } from "helper/PatientManagementHelper/PatientManagementHelper";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import OrdersHeader from "./Header/OrdersHeader";

const OrdersListBody = () => {
  const { t } = useTranslation();
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_APPOINTMENT_MANAGEMENT")
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Orders")}
          />
          <div className="container-fluid px-lg-5">
            <OrdersHeader />
          </div>

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default OrdersListBody;
